export const IconSizeEnum = Object.freeze({
  sm: 'sm',
  md: 'md',
  lg: 'lg',
})

export const IconTypeEnum = Object.freeze({
  add: 'add',
  arrowDown: 'arrowDown',
  arrowDownNav: 'arrowDownNav',
  burgerMenu: 'burgerMenu',
  carrouselArrow: 'carrouselArrow',
  contact: 'contact',
  logo: 'logo',
  logoHeader: 'logoHeader',
  logoHeaderMobile: 'logoHeaderMobile',
  logoHeaderTablet: 'logoHeaderTablet',
  search: 'search',
  footer: 'footer',
})
